import { render, staticRenderFns } from "./TournamentMatches.vue?vue&type=template&id=c2ccb6ee&"
import script from "./TournamentMatches.vue?vue&type=script&lang=js&"
export * from "./TournamentMatches.vue?vue&type=script&lang=js&"
import style0 from "./TournamentMatches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TournamentMatches.vue"
export default component.exports